import * as React from 'react';
import { inject } from '../../utils/decorators';
import * as ApiTypes from '../../models/ApiTypes';
import { AuftragStore } from '../../stores/AuftragStore';
import { Panel, Row, Col } from 'react-bootstrap';

interface IVorgangAuftragAdresseProps {
  adressArt: ApiTypes.AdressArt;
}

/** Komponente zur Anzeige einer im Auftrag hinterlegten Adresse innerhalb eines Vorgangs (zu Anzeigezwecken, kein Bearbeiten möglich) */
export default class VorgangAuftragAdresse extends React.Component<IVorgangAuftragAdresseProps> {

  @inject(AuftragStore) auftragStore: AuftragStore;

  render() {
    const auftrag = this.auftragStore.auftrag;

    if (!auftrag) {
      return (<div>Keine Adressdaten vorhanden</div>);
    }

    let strasse = '';
    let name = '';
    let ort = '';
    let caption = '';

    switch (this.props.adressArt) {
      case ApiTypes.AdressArt.Auftraggeber:
        caption = 'Auftraggeber';
        strasse = auftrag.auftraggeber_strasse;
        name = `${auftrag.auftraggeber_name1 || ''} ${auftrag.auftraggeber_name2 || ''} ${auftrag.auftraggeber_name3 || ''}`;
        ort = `${auftrag.auftraggeber_plz || ''} ${auftrag.auftraggeber_ort || ''}`;
        break;
      case ApiTypes.AdressArt.Beauftragter:
        caption = 'Ort der Kalibrierung';
        strasse = auftrag.beauftragter_strasse ? auftrag.beauftragter_strasse : '';
        name = `${auftrag.beauftragter_name1 || ''} ${auftrag.beauftragter_name2 || ''} ${auftrag.beauftragter_name3 || ''}`;
        ort = `${auftrag.beauftragter_plz || ''} ${auftrag.beauftragter_ort || ''}`;
        break;
      // Letztendlich nur ein Alias damit die Anzeige angepasst werden kann
      case ApiTypes.AdressArt.Lieferadresse:
        caption = 'Lieferadresse';
        strasse = auftrag.beauftragter_strasse ? auftrag.beauftragter_strasse : '';
        name = `${auftrag.beauftragter_name1 || ''} ${auftrag.beauftragter_name2 || ''} ${auftrag.beauftragter_name3 || ''}`;
        ort = `${auftrag.beauftragter_plz || ''} ${auftrag.beauftragter_ort || ''}`;
        break;
      default:
        strasse = '';
        name = '';
        ort = '';
    }

    // Hinweistext bei komplett leerer Adresse anzeigen
    if ((strasse === '') && (name === '') && (ort === '')) {
      return (
        <Panel header={caption}>
          <p>Im Auftrag wurde noch <b>keine Adresse</b> für {caption} hinterlegt.</p>
          <p>Wenn Adressinformationen in die Vorlage übernommen werden sollen, ergänzen Sie diese bitte im Auftrag.</p>
        </Panel>
      );
    }

    return (
      <Panel header={caption}>
        <p>Die im Auftrag hinterlegte Adresse wird in die Vorlage übernommen:</p>
        <div className="auftraggeber adress-daten-auftrag">
          <div className="auftraggeber-links">
            <Row>
              <Col sm={1}>Name:</Col>
              <Col sm={11}>{name}</Col>
            </Row>
            <Row>
              <Col sm={1}>Straße:</Col>
              <Col sm={11}>{strasse}</Col>
            </Row>
            <Row>
              <Col sm={1}>Ort:</Col>
              <Col sm={11}>{ort}</Col>
            </Row>
          </div>
        </div>
    </Panel>
    );
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/vorlagen/VorgangAuftragAdresse.tsx